import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { matchPath } from "react-router-dom";

import { LIVE_TRANSACTIONS_PATTERN } from "@/config/path";
import { AuthRole, StageAuth } from "@/store/AuthStore";
import { rootStore } from "@/store/RootStore";

import { Intercom } from "./Intercom";

const APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export const IntercomProvider = observer(() => {
  const { authStore, restaurantAccessStore } = rootStore;

  const isRestaurantUser =
    authStore.stage === StageAuth.AUTHENTICATED &&
    authStore.role === AuthRole.RESTAURANT &&
    Boolean(authStore.email);

  const isLiveTransactionRoute = !!matchPath(
    LIVE_TRANSACTIONS_PATTERN,
    location.pathname
  );

  useEffect(() => {
    const shutdownIntercom = () => {
      if (typeof window !== "undefined" && window.Intercom) {
        try {
          window.Intercom("shutdown");
        } catch (e) {
          console.warn("Intercom shutdown failed:", e);
        }
      }
    };

    if (!isRestaurantUser || isLiveTransactionRoute) {
      shutdownIntercom();
      return;
    }

    const createdAtUnix =
      authStore.createdAt instanceof Date
        ? Math.floor(authStore.createdAt.getTime() / 1000)
        : undefined;

    Intercom({
      app_id: APP_ID,
      user_id: authStore.id,
      email: authStore.email,
      name: authStore.userFullName,
      created_at: createdAtUnix,
      restaurant_access: authStore.restaurantAccess,
      ...(restaurantAccessStore.intercomCompany && {
        company: restaurantAccessStore.intercomCompany,
      }),
    });

    return shutdownIntercom;
  }, [
    isRestaurantUser,
    isLiveTransactionRoute,
    location.pathname,

    authStore.stage,
    authStore.role,
    authStore.email,
    authStore.createdAt,
    authStore.restaurantAccess,
    authStore.userFullName,

    restaurantAccessStore.intercomCompany,
  ]);

  return null;
});
